import { Injectable } from '@angular/core';
import { ToastMessageOptions } from 'primeng/api';
import { BehaviorSubject, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  private _toastSubject: BehaviorSubject<ToastMessageOptions> = new BehaviorSubject<ToastMessageOptions>({});
  public toast$ = this._toastSubject.asObservable().pipe(shareReplay());

  public add(toastMessageOptions: ToastMessageOptions) {
    this._toastSubject.next(toastMessageOptions)
  }
}
